// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"96234e8a","455":"c6a55401","726":"fefeca99","977":"d2a57f82"}[chunkId] + ".chunk.js";
};